var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 406,
    viewBox: "0 0 467 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_33_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.9543 9.95431 1 21 1H446C457.046 1 466 9.95431 466 21V384.5C466 395.546 457.046 404.5 446 404.5H21C9.95431 404.5 1 395.546 1 384.5V21Z",
    fill: "url(#paint0_linear_33_272)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.9543 9.95431 1 21 1H446C457.046 1 466 9.95431 466 21V384.5C466 395.546 457.046 404.5 446 404.5H21C9.95431 404.5 1 395.546 1 384.5V21Z",
    stroke: "url(#paint1_linear_33_272)",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_33_272",
    x: -30,
    y: -30,
    width: 527,
    height: 465.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33_272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_33_272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_272",
    x1: 236.591,
    y1: 151,
    x2: 254.206,
    y2: 327.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_272",
    x1: 662.681,
    y1: 244.244,
    x2: 116.137,
    y2: -181.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbox);
export default __webpack_public_path__ + "static/media/big box.1f156f3a970bd3d86960e9f3a22da629.svg";
export { ForwardRef as ReactComponent };